const scrollBehavior = () => {
    const isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);

    return  isChrome ? { block: 'start', behavior: 'smooth' } : { block: 'start' };
};

export default scrollBehavior;